import { render, staticRenderFns } from "./ExchangeFormPage.vue?vue&type=template&id=09c7f106&scoped=true"
import script from "./ExchangeFormPage.vue?vue&type=script&lang=js"
export * from "./ExchangeFormPage.vue?vue&type=script&lang=js"
import style0 from "./ExchangeFormPage.vue?vue&type=style&index=0&id=09c7f106&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c7f106",
  null
  
)

export default component.exports